<script>
import { Line, mixins } from "vue-chartjs";
import colorLib from "@kurkle/color";
const { reactiveProp, reactiveData } = mixins;

const COLOR_CHART = {
  LINE: "#3d7095",
  HORIZONTAL_LINE: "#B4C3C3"
};

const MAXIMUM_MILESTONES = 1500;
const RANGES_MILESTONES = [540, 740, 941];
const BACKGROUND_RULES = [
  {
    color: "transparent",
    mileStone: 740
  },
  {
    color: "#D3FFA8",
    mileStone: 941
  },
  {
    color: "transparent",
    mileStone: Infinity
  }
];

const getHorizontalLine = () => {
  return RANGES_MILESTONES.map(item => {
    return {
      y: item,
      style: COLOR_CHART.HORIZONTAL_LINE
    };
  });
};

const getBackgroundRules = () => {
  return BACKGROUND_RULES.map(item => {
    return {
      backgroundColor: item.color,
      yAxisSegement: item.mileStone
    };
  });
};

const transparentize = (value, opacity) => {
  const alpha = opacity === undefined ? 0.5 : 1 - opacity;
  return colorLib(value)
    .alpha(alpha)
    .rgbString();
};

const getLabel = data => {
  if (!data) return [];
  const labelData = data.map(item => item.date);
  return ["", ...labelData, ""];
};

const getDataset = data => {
  if (!data) return [];
  const scores = data.map(item => item.score);
  return [null, ...scores, null];
};

export default {
  extends: Line,
  mixins: [reactiveData],
  props: ["chartDataAssessment", "type"],
  data() {
    return {
      chartData: {
        labels: getLabel(this.chartDataAssessment),
        datasets: [
          {
            label: this.type === "SRI" ? "Lexile scores" : "Quantile scores",
            data: getDataset(this.chartDataAssessment),
            borderColor: COLOR_CHART.LINE,
            borderWidth: 1,
            backgroundColor: transparentize(COLOR_CHART.LINE, 0),
            tension: 0,
            pointStyle: "circle",
            pointRadius: 3,
            fill: false
          }
        ]
      },
      options: {
        maintainAspectRatio: false,
        responsive: true,
        legend: {
          display: false
        },
        horizontalLine: getHorizontalLine(),
        backgroundRules: getBackgroundRules(),
        scales: {
          xAxes: [
            {
              gridLines: {
                drawOnChartArea: false
              }
            }
          ],
          yAxes: [
            {
              gridLines: {
                drawOnChartArea: false
              },
              ticks: {
                beginAtZero: true,
                max: MAXIMUM_MILESTONES
              }
            }
          ]
        }
      }
    };
  },
  mounted() {
    this.addPlugin({
      id: "my-plugin",
      beforeDraw: function(chart) {
        const ctx = chart.chart.ctx;
        if (chart?.chart?.options?.backgroundRules) {
          let ruleIndex = 0;
          const rules = chart.chart.options.backgroundRules;
          const yaxis = chart.chart.scales["y-axis-0"];
          const xaxis = chart.chart.scales["x-axis-0"];
          const partPercentage = 1 / (yaxis.ticksAsNumbers.length - 1);
          for (let i = yaxis.ticksAsNumbers.length - 1; i > 0; i--) {
            if (yaxis.ticksAsNumbers[i] < rules[ruleIndex].yAxisSegement) {
              ctx.fillStyle = rules[ruleIndex].backgroundColor;
              ctx.fillRect(
                xaxis.left,
                yaxis.top + (i - 1) * (yaxis.height * partPercentage),
                xaxis.width,
                yaxis.height * partPercentage
              );
            } else {
              ruleIndex++;
              i++;
            }
          }
        }

        if (chart?.config?.options?.horizontalLine) {
          const horizontalLine = chart.config.options.horizontalLine;
          const xAxe = chart.scales[chart.config.options.scales.xAxes[0].id];
          const yAxe = chart.scales[chart.config.options.scales.yAxes[0].id];
          for (let item of horizontalLine) {
            const lineAt = yAxe.getPixelForValue(item.y);
            ctx.beginPath();
            ctx.lineWidth = 2;
            ctx.strokeStyle = item.style || "#B4C3C3";
            ctx.moveTo(xAxe.left, lineAt);
            ctx.lineTo(xAxe.right, lineAt);
            ctx.stroke();
          }
        }
      }
    });
    this.renderChart(this.chartData, this.options);
  }
};
</script>

<style lang="scss" scoped></style>
